// Non-schema EMPTY_FILE implementation
export const emptyFile = (schema, context)=>{
  if (context.file.size === 0 && !context.directory) {
    context.dataset.issues.add({
      code: 'EMPTY_FILE',
      location: context.path
    });
  }
  return Promise.resolve();
};
//# sourceMappingURL=emptyFile.js.map